import "./assets/scss/style.scss";

import { ViteSSG } from "vite-ssg";
import { createPinia } from "pinia";
import App from "./App.vue";
import { routes } from "./router";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { useServiceStore } from '@/stores/serviceStore';

const scrollPositions = {};

export const createApp = ViteSSG(
    App,
    {
        routes,
        scrollBehavior(to, from, savedPosition) {
            const storeScroll = useScrollStore();
            const headerOffset = storeScroll.header?.offsetHeight || 100;

            // if (to.hash) {
            //     return {
            //         el: to.hash,
            //         behavior: "smooth",
            //         top: headerOffset,
            //     };
            // }

            if (savedPosition) {
                return savedPosition;
            }

            const savedPos = scrollPositions[to.fullPath];
            if (savedPos) {
                return savedPos;
            }

            return { top: 0 };
        },
    },
    ({ app, router, initialState }) => {
        const pinia = createPinia();
        app.use(pinia);
        app.use(VCalendar, {});

        // Восстановление состояния Pinia на клиенте
        if (import.meta.env.SSR) {
            initialState.pinia = pinia.state.value;
        } else {
            pinia.state.value = initialState.pinia || {};
        }

        // Инициализация сторов перед навигацией
        router.beforeEach((to, from, next) => {
            if (typeof window !== 'undefined') {
                scrollPositions[from.fullPath] = {
                    left: window.scrollX,
                    top: window.scrollY,
                };
            }

            const storeRequests = useRequestsStore(pinia);
            const settingsStore = useSettingsStore(pinia);
            const scrollStore = useScrollStore(pinia);
            const storeService = useServiceStore(pinia);

            if (!storeRequests.ready) storeRequests.initialize?.();
            if (!settingsStore.ready) settingsStore.initialize?.();
            if (!scrollStore.ready) scrollStore.initialize?.();
            if (!storeService.ready) storeService.initialize?.();

            next();
        });
    }
);




// const app = createApp(App)
// app.use(createPinia())
// app.use(router)
// app.use(VCalendar, {});

// app.mount('#app')
